module.exports = __webpack_public_path__ + "files/d4e97c8ef93c7e57718d3dcc103680fd.png";